export const school = {
  name: "Toddler's Academy",
  tagline: 'we walk for the world',
  phone: '0800 114 2255',
  email: 'hello@toddlersacademy.sch',
  address: '14 Ogundele Way, Ikeja, Lagos',
  hours: 'Open 7:30am–5:00pm, Monday to Friday',
};

export const stats = [
  { value: '18', label: 'children in the average class — the national figure is 38' },
  { value: '31', label: 'teachers, 22 of them here longer than five years' },
  { value: '94%', label: 'of pupils stay with us from Grade 1 through Grade 10' },
  { value: '₦0', label: 'tuition — uniform, books and lunch are funded too' },
];
